<template>
    <div>
        <!-- navbar  -->
        <nav-bar />
        <!-- end of navbar  -->
        <branding :is-home="false" />
        <section class="products">
            <div class="common-header">
                <h1 class="common-heading">Products</h1>
                <div class="underline">
                    <div class="small-underline"></div>
                    <div class="big-underline"></div>
                </div>
            </div>

            <div class="products-cards-wrapper">
              <product-card product-id="11138"
                  product-title="Ultra Light Stretchable Capry for Your Sporty Little One"
                  product-description=""
                  size="S TO XXL"
                  :images="['/img/products/11138/11138_BLACK.webp',
                  '/img/products/11138/11138_DEEPBLUE.webp',
                  '/img/products/11138/11138_MUSTURD.webp',
                  '/img/products/11138/11138_RED.webp']"
              />
              <product-card product-id="11146"
                    product-title="Boys Printed Denim Capry"
                    product-description=""
                    size="S TO XXL"
                    :images="['/img/products/11146/11146_DENIMAX.webp']"
              />
              <product-card product-id="11179"
                    product-title="Boys Denim Half Dungree"
                    product-description=""
                    size="S TO XXL"
                    :images="['/img/products/11179/11179_DENIMAX.webp',
                    '/img/products/11179/11179_ICE.webp']"
              />
              <product-card product-id="p1"
                    product-title="Boys Stylish Camo Capry"
                    product-description=""
                    size="6 TO 16"
                    :images="['/img/products/p1/p1.webp']"
              />
              <product-card product-id="11128"
                    product-title="Printed Fancy Half Pant"
                    product-description=""
                    size="S TO XXL"
                    :images="['/img/products/11128/11128_KHAKHI.webp',
                    '/img/products/11128/11128_LIGHTGREY.webp',
                    '/img/products/11128/11128_PINK.webp',
                    '/img/products/11128/11128_PISTA.webp']"
              />
               <product-card product-id="11166"
                    product-title="Printed Fancy Half Pant Made With Soft
                    Stretchable Cotton Hosiery"
                    product-description=""
                    size="S TO XXL"
                    :images="['/img/products/11166/11166_PINK.webp',
                    '/img/products/11166/11166_SEAGREEN.webp']"
              />
              <product-card product-id="10988"
                    product-title="Round Elastic Lycra Denim Joggers"
                    product-description=""
                    size="16 TO 26"
                    :images="['/img/products/10988/10988_DENIMAX.webp',
                    '/img/products/10988/10988_ICE.webp']"
              />
              <product-card product-id="10996"
                    product-title="Round Elastic Comfort Fit Pant"
                    product-description=""
                    size="16 TO 26"
                    :images="['/img/products/10996/10996_DENIMAX.webp',
                    '/img/products/10996/10996_ICE.webp']"
              />
              <product-card product-id="11087"
                  product-title="Dungree Full Pant Made With Soft Stretchable Cotton Hosiery"
                  product-description=""
                  size="16 TO 30"
                  :images="['/img/products/11087/11087_GREY.webp',
                  '/img/products/11087/11087_LIGHT_PHONE.webp',
                  '/img/products/11087/11087_PHONE.webp']"
              />
              <product-card product-id="11086"
                  product-title="Dungree Full Pant Made With Soft Stretchable Cotton Hosiery"
                  product-description=""
                  size="16 TO 30"
                  :images="['/img/products/11086/11086_RED.webp']"
              />
              <product-card product-id="11022"
                    product-title="Ultra Comfy Round Elastic Cargo Joggers"
                    product-description=""
                    size="16 TO 26"
                    :images="['/img/products/11022/11022_ICE_BLUE.webp',
                    '/img/products/11022/11022_LIGHTPHONE.webp']"
              />
              <product-card product-id="11048"
                  product-title="Boys Side Tape Cotton Hosiery Pant"
                  product-description=""
                  size="16 TO 26"
                  :images="['/img/products/11048/11048_PINK.webp',
                  '/img/products/11048/11048_KHAKHI.webp',
                  '/img/products/11048/11048_PISTA.webp']"
              />
              <product-card product-id="10918"
                  product-title="Cargo Hosiery Denim Capry"
                  product-description=""
                  size="6 TO 16"
                  :images="['/img/products/10918/10918_BLACK.webp',
                  '/img/products/10918/10918_DENIMAX.webp']"
              />
              <product-card product-id="11111"
                  product-title="Comfort Fit Super Lycra Denim Best for Everyday Wear"
                  product-description=""
                  size="16 TO 30"
                  :images="['/img/products/11111/11111_BLACK.webp',
                  '/img/products/11111/11111_DENIMAX.webp',
                  '/img/products/11111/11111_DARKGREY.webp',
                  '/img/products/11111/11111_ICE.webp',
                  '/img/products/11111/11111_KHAKHI.webp',
                  '/img/products/11111/11111_PISTA.webp',
                  '/img/products/11111/11111_RAWWASH.webp',]"
              />
            </div>
        </section>
        <!-- footer -->
        <website-footer />
        <!-- end of footer -->
    </div>
</template>

<script>
// @ is an alias to /src
import NavBar from '../components/NavBar.vue';
import Branding from '../components/Branding.vue';
import WebsiteFooter from '../components/WebsiteFooter.vue';
import ProductCard from '../components/ProductCard.vue';

export default {
  name: 'Products',
  components: {
    NavBar,
    Branding,
    WebsiteFooter,
    ProductCard,
  },
  created() {
    this.$ga.page({
      page: '/products',
      title: 'Products',
      location: window.location.href,
    });
  },
};
</script>
